import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class NNAWidget extends Component {
  componentDidMount() {
    if (typeof (this.props.onComponentMountCallBack) === 'function') {
      return this.props.onComponentMountCallBack();
    }
    return null;
  }

  // Get component class names based on the componentName through props.
  // Customization to styling as this component is being called from different component levels.
  getWidgetClassName() {
    return classNames({
      'nna-widget': true,
      'minihelp-nna-widget': (this.props.componentName === 'minihelp' || this.props.componentName === 'mobileApp'),
    });
  }

  // Render widget.
  render() {
    const {
      title, subTitle, buttonText, onClickHandler, componentName,
    } = this.props;
    return (
      <div className={this.getWidgetClassName()}>
        <div className="nna-widget--title">{title}</div>
        <div className="nna-widget--sub_label">{subTitle}</div>
        <button className="nna-widget--started_button" onClick={() => onClickHandler()}>
          {buttonText}
        </button>
        {componentName === 'mobileApp' ? <span className="nna-widget--hr" /> : null}
      </div>
    );
  }
}

NNAWidget.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  buttonText: PropTypes.string,
  onClickHandler: PropTypes.func,
  componentName: PropTypes.string,
  onComponentMountCallBack: PropTypes.func,
};

export default NNAWidget;
